import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Observable } from "rxjs";
import { Apply } from '../../models/apply';
import { ApplyService } from '../../services/apply.service';

@Component({
  selector: 'app-apply-dialog',
  templateUrl: './apply-dialog.component.html',
  styleUrls: ['./apply-dialog.component.css']
})
export class ApplyDialogComponent implements OnInit {

  applies: Observable<Apply[]>;
  userId: string;
  applyLoading: boolean;
  applyMax: number = 1;
  applyPage: number = 1;
  applyTotal: number = 0;
  errorMessage: string;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public apply: ApplyService,
    public dialogRef: MdDialogRef<ApplyDialogComponent>) { }

  ngOnInit() {
    this.userId = this.data.userId;
    this.applyMax = this.data.applyMax;
    this.fetchApplies(1);
  }

  fetchApplies(page) {
    this.applyLoading = true;
    this.apply.getApply(this.userId, page, this.applyMax)
      .subscribe(
        res => {
          this.applyTotal = res.pagination.total;
          this.applyPage = page;
          this.applyLoading = false;
          this.applies = res.applicants;
        },
        error => {
          this.applyLoading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/apply-dialog/apply-dialog.component.ts